<div>
  <i *ngFor="let rate of rates" [ngClass]="rate"></i>
</div>
